export enum SettingsItems {
  persona = 'persona',
  prompt = 'prompt',
  maxTokens = 'maxTokens',
  lastMessages = 'lastMessages',
  reasoningEffortLevel = 'reasoningEffortLevel',
}
